import React, { useState, useRef, useEffect } from 'react';
import { getData, postData } from "../../../../ApiServices/ApiService";
import {
    ORG_PROGRESS_CARD_REPORT_GENERATE, ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, ORG_GET_CONSOLIDATE_REPORT,
    ORG_GET_TEAM_LIST, ORG_GET_EMPLOYEE_LIST, ORG_GET_TO_DO_REPORT, ORG_GET_CLIENT_ACTIVITY_REPORT,ORG_GET_WORK_PROCESS_REVENUE_REPORT,
    ORG_GET_TASK_COMMENTS_REPORT, ORG_EMP_SEARCH_TO_ADD_TEAMMEMBER,ORG_GET_USER_ACTIVITY_REPORT, ORG_GET_GROUP_LIST, ORG_GET_BULK_TASK_LOG_REPORT,ORG_GET_EMPLOYEE_REPORT,
    ORG_GET_EMPLOYEE_PAYOUT_REPORT, ORG_GET_ATTENDANCE_REPORT, ORG_GET_USER_LOGIN_REPORT
} from '../../../../ApiServices/BaseURL';
import { logFrontendException } from '../../../../Utils/Exception';
import { useTheme } from '../../../../GlobalContext/GlobalContext';

const GenerateProgressReportController = () => {
    const [reportName, setReportName] = useState(null);
    const [status, setStatus] = useState(null);
    const [statusError, setStatusError] = useState(null);
    const pageName = 'GenerateProgressReportController';
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
    const { setIsLoginPopup } = useTheme();
    const [startDate, setStartDate] = useState("");
    const [startDateError, setStartDateError] = useState("");
    const [endDate, setEndDate] = useState("");
    const [endDateError, setEndDateError] = useState("");
    const [monthYear, setMonthYear] = useState("");
    const [monthYearError, setMonthYearError] = useState("");

    const [generateReportLoading, setGenerateReportLoading] = useState(false);
    const [generateReportError, setGenerateReportError] = useState("");
    const [generateReportSuccess, setGenerateReportSuccess] = useState("");
    const [reportNameError, setReportNameError] = useState('');

    const [searchClient, setSearchClient] = useState('');
    const [clientError, setClientError] = useState('');
    const [clientList, setClientList] = useState([]);
    const [clientSearchError, setClientSearchError] = useState('');
    const [clientListLoading, setClientListLoading] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);

    const [groupClientOptionsList, setGroupClientOptionsList] = useState([]);
    const [groupLoading, setGroupLoading] = useState(false)
    const [groupClientError, setGroupClientError] = useState('');
    const [groupClient, setGroupClient] = useState(null);

    const [roleType, setRoleType] = useState(null)
    const [roleTypeError, setRoleTypeError] = useState('')
    const [reportype, setReportType] = useState(null)
    const [reportypeError, setReportTypeError] = useState(null)
    const [bulkType, setBulkType] = useState(null)
    const [bulkTypeError, setBulkTypeError] = useState(null)

    const [searchUser, setSearchUser] = useState('');
    const [userError, setUserError] = useState('');
    const [userList, setUserList] = useState([]);
    const [userSearchError, setUserSearchError] = useState('');
    const [userListLoading, setUserListLoading] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    const accountantList = useRef([]);
    const teamLeaderList = useRef([]);
    const teamManagerList = useRef([]);
    const superAdminList = useRef([]);
    const adminList = useRef([]);
    const charteredAccountantList = useRef([]);
    const [reportNameOptions,setReportNameOptions]=useState([])

    const reportNameOptionsList = [{ label: 'Employee Report', value: 'employee_report' }, { label: 'Work Process Revenue', value: 'work_process_revenue_report' },
    { label: 'Consolidated Report', value: 'consolidate_report' }, { label: 'User Activity Report', value: 'user_activity_report' }, { label: 'To-Do List Report', value: 'todo_report' },
    { label: 'Employee Payout Report', value: 'employee_payout_report' }, { label: 'Attendance Report', value: 'attendance_report' }, { label: 'User Login Report', value: 'user_login_report' },
    { label: 'Bulk Task Log', value: 'bulk_task_log_report' }, { label: 'Schedule Report', value: 'schedule_report' }, { label: 'Export Task Comments', value: 'export_task_comments_report' }, { label: 'Client Activity Report', value: 'client_activity_report' }];

    // Mapping between per_name_sub_json keys and report option values
const reportPermissionMap = {
    "emp_report": "employee_report",
    "work_process_rev_report": "work_process_revenue_report",
    "consolidate_report": "consolidate_report",
    "user_act_report": "user_activity_report",
    "to_do_list_report": "todo_report",
    "emp_payout_report": "employee_payout_report",
    "attendance_report": "attendance_report",
    "user_login_report": "user_login_report",
    "bulk_task_log": "bulk_task_log_report",
    "schedule_report": "schedule_report",
    "export_task_comments": "export_task_comments_report",
    "client_act_report": "client_activity_report"
};
    const roleTypesOptions = [
        { label: 'Userwise', value: 'user_wise' },
        { label: 'Team Wise', value: 'team_wise' },
        { label: 'Team Leader', value: 'team_leader' },
        { label: 'Team Manager', value: 'team_manager' },
        { label: 'Chartered Accountant', value: 'chartered_accountant' },
        { label: 'Admin', value: 'admin' },
        { label: 'Super Admin', value: 'super_admin' }
    ];
    const reportTypesOptions = [
        { label: 'Userwise', value: 'user_wise' },
        { label: 'Team Wise', value: 'team_wise' },
    ];

    const bulkTypesOptions = [
        { label: 'Opening Balance', value: 'balance_log' },
        { label: 'Tasks', value: 'task_log' },
        { label: 'Clients', value: 'client_log' },
        {label:'Configuration Bulk Upload', value:'contacts_log'}
    ];

    const scheduleStatusOptions = [{ label: 'Attended', value: 1 }, { label: 'Not Attended', value: 2 }, { label: 'Pending', value: 3 }];
    const toDoStatusOptions = [{ label: 'Completed', value: 1 }, { label: 'Not Completed', value: 2 }, { label: 'Pending', value: 3 }, { label: 'Expired', value: 4 }];
    const taskStatusOptions = [{ label: 'Completed', value: 3 }, { label: 'In Progress', value: 2 }, { label: 'Not Started', value: 1 }];
    const statusOptions = [{ label: 'Completed', value: 3 }, { label: 'Pending', value: 2 }];

    const statusDropdownOptionsMap = {
        schedule_report: scheduleStatusOptions,
        todo_report: toDoStatusOptions,
        consolidate_report: statusOptions,
        employee_report: statusOptions,
        // export_task_comments_report: taskStatusOptions,
    };

    const clientSearchMap = {
        // schedule_report: '',
        // todo_report: '',
        client_activity_report: '',
        work_process_revenue_report: '',
        export_task_comments_report: '',
    }
    const shouldShowClientSearch = reportName?.value in clientSearchMap;
    const shouldShowStatusDropdown = reportName?.value in statusDropdownOptionsMap;
    const dropdownOptions = statusDropdownOptionsMap[reportName?.value] || [];

    const [selectedRoleType, setselectedRoleType] = useState([]);
    const [selectedRoleTypesOptions, setSelectedRoleTypesOptions] = useState([]);
    const [selectedTeamId, setselectedTeamId] = useState(null);
    const [selectedRoleError, setselectedRoleError] = useState('');


      const [userPermissions, setUserPermissions] = useState(null);
  useEffect(() => {
    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
    setUserPermissions(storedUserInfo?.user_permissions || {});
  }, [])

    useEffect(()=>{
    if(userPermissions){
        console.log('userPermissions',userPermissions)
// Filter the report options
const filteredReportNameOptions = reportNameOptionsList.filter(option => {
    const permissionKey = Object.keys(reportPermissionMap).find(key => reportPermissionMap[key] === option.value);
    return userPermissions?.progress_card?.per_name_sub_json[permissionKey] === 1;
});
    setReportNameOptions(filteredReportNameOptions || [])
    }

  },[userPermissions])

    useEffect(() => {
        fetchGroupList();
        fetchTeamList();
        fetchUserList();
    }, [])

    const downloadFile = (url) => {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Schedule Report.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const generateReportValidation = () => {
        try {
            setGenerateReportError('');
            setGenerateReportSuccess('');
            setReportNameError('');
            setStatusError(''); setStartDateError(''); setEndDateError('');
            setBulkTypeError('');
            setRoleTypeError('');setselectedRoleError('');
            setMonthYearError('');
            if (!reportName) {
                setReportNameError('Please select report name');
                return
            }
            var storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            if (reportName?.value === 'schedule_report') {
                if (startDate > endDate) {
                    setGenerateReportError('Start date should be less than end date');
                    return
                }

                const payLoad = {
                    emp_id_auth: storedUserInfo?.emp_id,
                    emp_id: selectedUser?.emp_id,
                    report_name: reportName?.value || '',
                    statsCode: status?.value || 0,
                    start_date: startDate || '',
                    end_date: endDate || ''
                }
                generateProgressReport(ORG_PROGRESS_CARD_REPORT_GENERATE, payLoad);
            } else if (reportName?.value === 'employee_report') {
                if (!status) {
                    setStatusError('Please select status'); return
                }
                if (startDate > endDate) {
                    setGenerateReportError('Start date should be less than end date');
                    return
                }
                const empIds = selectedRoleType?.map((item) => item?.value);  // Extract their ids
                const payLoad = {
                    "emp_id_auth": storedUserInfo?.emp_id,
                    "role_type": roleType?.value || '',
                    "user_list": roleType?.value === 'user_wise' ? selectedUser?.emp_id ? [selectedUser.emp_id] : [] : empIds || [],
                    "report_name": reportName?.value || '',
                    "task_status": status?.value || 0,
                    "start_date": startDate || '',
                    "end_date": endDate || ''
                }
                generateProgressReport(ORG_GET_EMPLOYEE_REPORT,payLoad);

            } else if (reportName?.value === 'work_process_revenue_report') {
                if(startDate){
                    if(!endDate){
                        setEndDateError('Please select end date');
                        return;
                    }
                }
                if(endDate){
                    if(!startDate){
                        setStartDateError('Please select start date');
                        return;
                    }
                }
                if (startDate > endDate) {
                    setGenerateReportError('Start date should be less than end date');
                    return
                }
                
                const payLoad = {
                    emp_id_auth: storedUserInfo?.emp_id,
                    client_id: selectedClient?.client_id || 0,
                    group_id: groupClient?.value || 0,
                    report_name: reportName?.value || '',
                    start_date: startDate || '',
                    end_date: endDate || ''
                }
                console.log('revenue payLoad:-', payLoad);
                generateProgressReport(ORG_GET_WORK_PROCESS_REVENUE_REPORT, payLoad);
            } else if (reportName?.value === 'consolidate_report') {

                if(roleType?.value === 'user_wise'){
                    if(!selectedUser?.emp_id){
                        setUserError('Please enter the user name and search.');return
                    }

                }else if(roleType?.value){
                    if(selectedRoleType?.length <= 0){
                        setselectedRoleError('Please select the team or user ');return
                    }
                    
                }
                if (!status) {
                    setStatusError('Please select status'); return
                }

                if (!startDate) {
                    setStartDateError('Please select start date');
                    return;
                }
                if(status?.value === 3){
                
                if (!endDate) {
                    setEndDateError('Please select end date');
                    return;
                }
                
                const start = new Date(startDate);
                const end = new Date(endDate);
                
                if (start > end) {
                    setGenerateReportError('Start date should be less than end date');
                    return;
                }

                // Include both start and end dates
                const dayDiff = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;
                console.log('dayDiff', dayDiff)

                // Check if Feb 29 exists in range without looping
                const leapDates = [
                    new Date(`${start.getFullYear()}-02-29`),
                    new Date(`${end.getFullYear()}-02-29`)
                ];
                const includesLeapDay = leapDates.some(
                    (date) => date.getDate() === 29 && date.getMonth() === 1 && date >= start && date <= end
                );
                
                if (dayDiff > (includesLeapDay ? 366 : 365)) {
                    setGenerateReportError("Date range should not exceed 365 days. Leap years may allow 366 days.");
                    return;
                }
            }
                
                const empIds = selectedRoleType?.map((item) => item?.value);  // Extract their ids
                const payLoad = {
                    "emp_id_auth": storedUserInfo?.emp_id,
                    "role_type": roleType?.value || '',
                    "user_list": roleType?.value === 'user_wise' ? [selectedUser?.emp_id || ''] : empIds || [],
                    "report_name": reportName?.value || '',
                    "task_status": status?.value || 0,
                    "from_date": startDate || '',
                    "to_date" : status?.value === 3 ? endDate || '' : '',
                }
                generateProgressReport(ORG_GET_CONSOLIDATE_REPORT, payLoad);

            } else if (reportName?.value === 'user_activity_report') {

                if(!reportype?.value){
                    setRoleTypeError('Please select report type');return
                }else{
                    
                    if(reportype?.value === 'user_wise'){
                        if(!selectedUser?.emp_id){
                            setUserSearchError('Please enter the user name and search.');return
                        }
                        
                    }else{
                        if(!selectedTeamId?.value){
                            setselectedRoleError('Please select the team');return
                        }
                    }
                }
              
                if (!startDate) {
                    setStartDateError('Please select start date'); return
                }
                if (!endDate) {
                    setEndDateError('Please select end date'); return
                }
                const start = new Date(startDate);
                const end = new Date(endDate);

                if (start > end) {
                    setGenerateReportError('Start date should be less than end date');
                    return;
                }

                // Check if date range exceeds 15 days
                const timeDiff = Math.abs(end - start);
                const dayDiff = timeDiff / (1000 * 60 * 60 * 24);

                if (dayDiff > 14) {
                    setGenerateReportError('Date range should not exceed 15 days');
                    return;
                }
                const payLoad = {
                    "emp_id_auth": storedUserInfo?.emp_id,
                    "report_type": reportype?.value || '',
                    "user_id": reportype?.value === 'user_wise' ? selectedUser?.emp_id : selectedTeamId?.value || 0,
                    "report_name": reportName?.value || '',
                    "start_date": startDate || '',
                    "end_date": endDate || ''
                }
                console.log('payload user:-',payLoad);
                generateProgressReport(ORG_GET_USER_ACTIVITY_REPORT, payLoad);
            } else if (reportName?.value === 'todo_report') {
                if (!startDate) {
                    setStartDateError('Please select start date'); return
                }
                if (!endDate) {
                    setEndDateError('Please select end date'); return
                }
                if (startDate > endDate) {
                    setGenerateReportError('Start date should be less than end date');
                    return
                }

                const payLoad = {
                    emp_id_auth: storedUserInfo?.emp_id,
                    emp_id: selectedUser?.emp_id,
                    report_name: reportName?.value || '',
                    statsCode: status?.value || 0,
                    start_date: startDate || '',
                    end_date: endDate || ''
                }
                generateProgressReport(ORG_GET_TO_DO_REPORT, payLoad);

            } else if (reportName?.value === 'bulk_task_log_report') {

                if (!bulkType?.value) {
                    setBulkTypeError('Please select bulk type'); return
                }
                if (!startDate) {
                    setStartDateError('Please select start date'); return
                }
                if (!endDate) {
                    setEndDateError('Please select end date'); return
                }
                if (startDate > endDate) {
                    setGenerateReportError('Start date should be less than end date');
                    return
                }
                const payLoad = {
                    emp_id_auth: storedUserInfo?.emp_id,
                    bulk_type: bulkType?.value || '',
                    report_name: reportName?.value || '',
                    from_date: startDate || '',
                    to_date: endDate || ''
                }
                generateProgressReport(ORG_GET_BULK_TASK_LOG_REPORT, payLoad);

            } else if (reportName?.value === 'export_task_comments_report') {
                if (!startDate) {
                    setStartDateError('Please select start date'); return
                }
                if (!endDate) {
                    setEndDateError('Please select end date'); return
                }
                const start = new Date(startDate);
                const end = new Date(endDate);

                if (start > end) {
                    setGenerateReportError('Start date should be less than end date');
                    return;
                }

                // Check if date range exceeds 15 days
                const timeDiff = Math.abs(end - start);
                const dayDiff = timeDiff / (1000 * 60 * 60 * 24);

                if (dayDiff > 14) {
                    setGenerateReportError('Date range should not exceed 15 days');
                    return;
                }


                const payLoad = {
                    emp_id_auth: storedUserInfo?.emp_id,
                    client_id: selectedClient?.client_id || 0,
                    group_id: groupClient?.value || 0,
                    report_name: reportName?.value || '',
                    // service_check_status: status?.value || 0,
                    start_date: startDate || '',
                    end_date: endDate || ''
                }
                console.log('task payLoad:-', payLoad)
                generateProgressReport(ORG_GET_TASK_COMMENTS_REPORT, payLoad);

            } else if (reportName?.value === 'client_activity_report') {
                if (!selectedClient?.client_id) {
                    setClientError('Please enter the client name and search.'); return
                }
                if (startDate > endDate) {
                    setGenerateReportError('Start date should be less than end date');
                    return
                }
                const payLoad = {
                    emp_id_auth: storedUserInfo?.emp_id,
                    client_id: selectedClient?.client_id || 0,
                    report_name: reportName?.value || '',
                    start_date: startDate || '',
                    end_date: endDate || ''
                }
                console.log('task payLoad:-', payLoad);
                generateProgressReport(ORG_GET_CLIENT_ACTIVITY_REPORT, payLoad);


            } else if (reportName?.value === 'employee_payout_report') {
                const payLoad = {
                    emp_id_auth: storedUserInfo?.emp_id,
                    report_name: reportName?.value || ''
                }
                console.log("payLoad in employee payout report", payLoad)
                generateProgressReport(ORG_GET_EMPLOYEE_PAYOUT_REPORT, payLoad);
            } else if (reportName?.value === 'attendance_report') {
                if (!monthYear) {
                    setMonthYearError('Please select month & year to proceed.');
                    return;
                }
                const payLoad = {
                    emp_id_auth: storedUserInfo?.emp_id,
                    report_name: reportName?.value || '',
                    year_month: monthYear || ''
                }
                console.log("payLoad in attendance report", payLoad)
                generateProgressReport(ORG_GET_ATTENDANCE_REPORT, payLoad);
            } else if (reportName?.value === 'user_login_report') {
                if(!selectedUser?.emp_id){
                    setUserError('Please search and select a user.');return
                    setUserSearchError('Please enter the user name and search.');return
                }
                if (!monthYear) {
                    setMonthYearError('Please select month & year to proceed.');
                    return;
                }
                const payLoad = {
                    emp_id_auth: storedUserInfo?.emp_id,
                    report_name: reportName?.value || '',
                    year_month: monthYear || '',
                    emp_id: selectedUser?.emp_id || 0
                }
                console.log("payLoad in user login report", payLoad)
                generateProgressReport(ORG_GET_USER_LOGIN_REPORT, payLoad);
            } else {
                console.log('reportName else', reportName);
            }
        } catch (error) {
            console.log('validations error:', error)

        }


    }

    const generateProgressReport = async (endPoint, payLoad) => {
        try {
            console.log("payLoad in progress card report", payLoad)

            setGenerateReportLoading(true);
            // Make the API call
            const response = await postData(endPoint, payLoad);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.status_code === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            const downloadUrl = responseData?.dataJ[0]?.download_url;
                            console.log("Download URL:", downloadUrl);
                            if (!downloadUrl) {
                                setGenerateReportError(responseData?.info || 'Excel Not Found'); return
                            }
                            downloadFile(downloadUrl);
                            // resetFilter();
                            setGenerateReportSuccess(responseData?.info);
                            setTimeout(() => {
                                setGenerateReportSuccess('');
                            }, 3000);
                        } else {
                            setGenerateReportError(responseData?.info || 'Report Not Found');
                            logFrontendException(storedUserId, pageName, `ProgressReport-${endPoint}`, responseData?.info || '');
                        }
                    } else {
                        setGenerateReportError(responseData?.info || 'Failed to download report. Please try again.');
                        logFrontendException(storedUserId, pageName, `ProgressReport-${endPoint}`, responseData?.info || '');
                    }
                } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                    setGenerateReportError("Unauthorized access. Your session may have expired. Please log in again.");
                    setIsLoginPopup(true);
                } else {
                    setGenerateReportError(responseData?.info || 'Failed to download report.');
                    logFrontendException(storedUserId, pageName, `ProgressReport-${endPoint}`, responseData || '');
                }
            }else {
                setClientError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, `ProgressReport-${endPoint}`, response || '');
            }
        } catch (error) {
            console.log('error:-', error)
            // Handle various error scenarios
            setGenerateReportError(`Failed to download report. Please check your network connection and try again.`);
            logFrontendException(storedUserId, pageName, `ProgressReport-catch-${endPoint}`, error || '');

        } finally {
            setGenerateReportLoading(false);
            // showFilter();
        }
    }



    const handleSearchClient = async () => {

        try {
            setClientError('');
            setClientSearchError('');
            if (!searchClient) {
                setClientSearchError('Please enter valid text'); return;
            }
            setClientListLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "GENERIC", search_word: searchClient }

            //console.log('handleSearchClient payload', payLoad);
            // Make the API call
            const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        // setAddEmployeeError('')
                        setClientList(responseData?.dataJ || []);
                        //   setClientError(responseData?.info);
                        setTimeout(() => {
                            // handleClose();
                            // onValueChange();
                        }, 2000);
                    } else {
                        setClientError(responseData?.info || 'Failed to fetch client data. Please try again.');
                    }
                } else {
                    setClientError(responseData?.info || 'Failed to fetch client data.');
                }
            }
            else {
                setClientError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // An error occurred in setting up the request
            setClientError(`Failed to fetch client data. Please check your network connection and try again.`);

        } finally {
            setClientListLoading(false);
        }
    };

    const handleSearchInputChange = (value) => {
        setSearchClient(value);
        setGroupClient(null);
        setSelectedClient(null);
        setClientList([])
    }
    const handleSelectedClient = (employee) => {
        setSelectedClient(employee);
        setSearchClient(employee?.client_name);

        setClientList([]); // Clear the dropdown
    };

    const resetFilter = () => {
        setReportName(''); setReportNameError('');
        setStartDate(''); setStartDateError('');
        setEndDate(''); setEndDateError('')
        setSelectedClient(null); setSearchClient(null); setClientSearchError(''); setClientError('');
        setGenerateReportError('');
        setStatus(''); setStatusError('')
        setRoleType(null);setRoleTypeError('');setselectedRoleError('')
        setReportType(null);
        setBulkType(null); setBulkTypeError('');
        setSearchUser(''); setSelectedUser(null); setUserSearchError('');
        setGroupClient(null);
        setselectedRoleType([]);
        setMonthYear(''); setMonthYearError('');
    }

    const fetchGroupList = async () => {
        try {
            setGroupClientError('')
            setGroupLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const response = await getData(`${ORG_GET_GROUP_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            // Transforming the data
                            const filterData = responseData?.dataJ.map(service => ({
                                label: service.group_name,
                                value: service.group_id
                            }));
                            setGroupClientOptionsList(filterData)
                        } else {
                            setGroupClientError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setGroupClientError(responseData?.info || 'Failed to fetch group list. Please try again.');
                    }
                } else {
                    setGroupClientError(responseData?.info || 'Failed to fetch group list.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setGroupClientError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true)

            }
            else {
                setGroupClientError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            setGroupClientError(`Failed to fetch group list. Please check your network connection and try again.`);

        } finally {
            setGroupLoading(false);
        }
    }

    const handleUserInputChange = (value) => {
        setSearchUser(value);
        setSelectedUser(null)
        setUserList([]);

    }

    const handleSelectedUser = (employee) => {
        setSelectedUser(employee);
        setSearchUser(employee?.emp_name);

        setUserList([]); // Clear the dropdown
    };

    const handleSearchUser = async () => {

        try {
            setUserError('');
            setUserSearchError('');
            if (!searchUser) {
                setUserSearchError('Please enter valid text'); return;
            }
            setUserListLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "GENERIC", search_word: searchUser }

            //console.log('handleSearchClient payload', payLoad);
            // Make the API call
            const response = await postData(ORG_EMP_SEARCH_TO_ADD_TEAMMEMBER, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setUserList(responseData?.dataJ || []);

                    } else {
                        setUserError(responseData?.info || 'Failed to fetch client data. Please try again.');
                    }
                } else {
                    setUserError(responseData?.info || 'Failed to fetch client data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setUserError('Unauthorized access. Your session may have expired. Please log in again.');

            }
            else {
                setUserError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // An error occurred in setting up the request
            setUserError(`Failed to fetch client data. Please check your network connection and try again.`);

        } finally {
            setUserListLoading(false);
        }
    };

    const handleMonthYearChange = (value) => {
        console.log('handleMonthYearChange value', value)
        setMonthYear(value);
    }

 


    // Add more lists as needed

    const handleRoleTypeChange = (selected) => {
        setRoleType(selected);

        switch (selected?.value) {
            case "team_wise":
                setSelectedRoleTypesOptions(teamListOptions);
                break;
            case "team_leader":
                console.log('teamLeaderList.current:-', teamLeaderList.current)
                setSelectedRoleTypesOptions(teamLeaderList.current);
                break;
            case "team_manager":
                setSelectedRoleTypesOptions(teamManagerList.current);
                break;
            case "chartered_accountant":
                setSelectedRoleTypesOptions(charteredAccountantList.current);
                break;
            case "admin":
                setSelectedRoleTypesOptions(adminList.current);
                break;
            case "super_admin":
                setSelectedRoleTypesOptions(superAdminList.current);
                break;
            case "accountant":
                setSelectedRoleTypesOptions(accountantList.current.current);
                break;
            default:
                setSelectedRoleTypesOptions([]);
        }

        // Clear previous selection
        setselectedRoleType([]);
    };

    const handleReportType = (selected) => {
        setReportType(selected)
        if (selected?.value === 'team_wise') {
            console.log('teamListOptions')
            setSelectedRoleTypesOptions(teamListOptions);
        } else {
            setSelectedRoleTypesOptions([])
        }
    }
    const [teamListOptions, setTeamListOptions] = useState([]);
    const [teamListLoading, setTeamListLoading] = useState(false);
    const [teamListerror, setTeamListError] = useState('');
    const fetchTeamList = async () => {
        try {
            setTeamListLoading(true);
            setTeamListError('');
            setTeamListOptions([]);


            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const response = await getData(`${ORG_GET_TEAM_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            const filterData = responseData?.dataJ.map(service => ({
                                label: service?.team_name,
                                value: service?.team_id
                            }));
                            setTeamListOptions(filterData)
                        } else {
                            setTeamListError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setTeamListError(responseData?.info || 'Failed to fetch team list. Please try again.');
                    }
                } else {
                    setTeamListError(responseData?.info || 'Failed to fetch team list.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setTeamListError('Unauthorized access. Your session may have expired. Please log in again.');

            }
            // Unexpected or network-related errors
            else {
                setTeamListError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {

            setTeamListError(`Failed to fetch team list. Please check your network connection and try again.`);

        } finally {
            setTeamListLoading(false);
        }
    }

    const filterListRoleBased = (employeeList) => {
        try {
            // Step 2: Filter and store options for each role
            accountantList.current = employeeList
                .filter(emp => emp.role_id === 104)
                .map(emp => ({ label: emp.emp_name, value: emp.emp_id }));

            teamLeaderList.current = employeeList
                .filter(emp => emp.role_id === 103)  // If both mean team leaders in your case
                .map(emp => ({ label: emp.emp_name, value: emp.emp_id }));

            teamManagerList.current = employeeList
                .filter(emp => emp.role_id === 102)
                .map(emp => ({ label: emp.emp_name, value: emp.emp_id }));

            superAdminList.current = employeeList
                .filter(emp => emp.role_id === 105)
                .map(emp => ({ label: emp.emp_name, value: emp.emp_id }));

            adminList.current = employeeList
                .filter(emp => emp.role_id === 106)
                .map(emp => ({ label: emp.emp_name, value: emp.emp_id }));

            charteredAccountantList.current = employeeList
                .filter(emp => emp.role_id === 101) // If role_id 101 is for CA
                .map(emp => ({ label: emp.emp_name, value: emp.emp_id }));

        } catch (error) {
            console.log('error filter:-', error)
        }
    }

    const [userListOptions, setUserListOptions] = useState([]);
    const [userLoading, setUserLoading] = useState(false);
    const [userListError, setUserListError] = useState('');

    const fetchUserList = async () => {
        try {
            setUserLoading(true);
            setUserListError('');
            setUserListOptions([]);

            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const response = await getData(`${ORG_GET_EMPLOYEE_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            // const filterData = responseData?.dataJ.map(service => ({
                            //     label: service?.emp_name,
                            //     value: service?.emp_id
                            // }));
                            // setUserListOptions(filterData);
                            filterListRoleBased(responseData?.dataJ);
                        } else {
                            setUserListError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setUserListError(responseData?.info || 'Failed to fetch User data. Please try again.');
                    }
                } else {
                    setUserListError(responseData?.info || 'Failed to fetch User data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setUserListError('Unauthorized access. Your session may have expired. Please log in again.');

            }
            // Unexpected or network-related errors
            else {
                setUserListError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {

            setUserListError(`Failed to fetch User data. Please check your network connection and try again.`);

        } finally {
            setUserLoading(false);
        }
    }

    const handleReportName = (selected) => {
        setReportName(selected);
        setRoleType(null);
        setReportType(null);setselectedRoleError('')
        setBulkType(null);
        setSearchUser(''); setSelectedUser(null);
        setSearchClient(null); setSelectedClient(null);
        setGroupClient(null);
        setGenerateReportError('');
        setStartDate('');setClientSearchError(''); setClientError('');
        setEndDate(''); setselectedRoleType([]);setRoleTypeError('');
        setStartDateError('');setEndDateError('');
        setBulkTypeError('');setUserSearchError('');setUserError('');
        setStatus(null);
        setMonthYear(''); setMonthYearError('');

    }
    return {
        reportName, handleReportName, statusError, startDateError, endDateError, monthYearError, handleMonthYearChange,
        status, setStatus, startDate, setStartDate, endDate, setEndDate, monthYear, 
        generateReportSuccess, generateReportError, generateReportLoading,
        handleSearchClient, clientListLoading, clientSearchError, clientList,
        clientError, handleSearchInputChange, handleSelectedClient,
        searchClient, generateReportValidation, resetFilter, reportNameError,
        reportNameOptions, roleTypesOptions, roleType, handleRoleTypeChange,
        shouldShowStatusDropdown, dropdownOptions, groupClient, setGroupClient,
        groupClientOptionsList, groupLoading, groupClientError, bulkTypesOptions,
        shouldShowClientSearch, reportTypesOptions, reportype, handleReportType,
        bulkType, setBulkType, handleSearchUser, userListLoading, userSearchError,
        userList, userError, handleUserInputChange, handleSelectedUser, searchUser,
        selectedRoleTypesOptions, selectedRoleType, setselectedRoleType,selectedRoleError,
        userLoading, bulkTypeError,selectedTeamId, setselectedTeamId, roleTypeError
    }
}

export default GenerateProgressReportController